import { emailRegex } from "constants";

const formatEmailList = (emails) => {
    if (Array.isArray(emails)) {
      return emails
        .map(email => (email.recipient || email.address || email)) // Handle different properties and single values
        .join(', ');
    }
    return emails;
  };

const validateEmailList = (emailList, requireAtLeastOne = true) => {
    if (!emailList || (Array.isArray(emailList) && emailList.length === 0)) {
        return !requireAtLeastOne;
    }

    let emails = [];

    if (typeof emailList === 'string') {
        emails = emailList
            .split(',')
            .map(email => email.trim())
            .filter(email => email !== '');
    } else if (Array.isArray(emailList)) {
        emails = emailList
            .map(email => email.trim())
            .filter(email => email !== '');
    } else {
        return false;
    }

    if (emails.length === 0) {
        return !requireAtLeastOne;
    }

    return emails.every(email => emailRegex.test(email));
};


export { formatEmailList, validateEmailList };